import React, { useEffect, useState } from 'react'

import {
    Typography, Paper, TextField, InputAdornment,
    Stack, Grid, useMediaQuery, FormControl, InputLabel, OutlinedInput, IconButton, Button, Snackbar, Alert
} from '@mui/material';

import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from '../components/SEO';

import { Box } from '@mui/system';

import { EditOutlined, LogoutOutlined, SaveOutlined, Visibility, VisibilityOff } from '@mui/icons-material';

import Menu from '../components/Menu';
import BottomMenu from '../components/BottomMenu';
import { useDispatch, useSelector } from 'react-redux';
import { userLogout } from '../redux/actions/userAction';
import { updateProfile } from '../utils/firebase';

export default function Notifications() {
    const matches = useMediaQuery('(max-width:1150px)');
    const fullScreen = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    const screenSize = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    const user = useSelector((state => state.user))

    const style = {
        background: {
            paddingLeft: 2,
            paddingRight: 2,
            borderRadius: 0,
            paddingBottom: 0,
            paddingTop: 5,
            '@media only screen and (max-width: 900px)': {
                paddingTop: 2
            },

        },
        body: {
            '@media only screen and (min-width: 480px)': {
                marginLeft: '4%',
                marginRight: '4%',
            },
            '@media only screen and (min-width: 1700px)': {
                marginLeft: '15%',
                marginRight: '15%',
            },
        },
        linkTexts: {
            textTransform: "none",
            color: (theme) => theme.palette.text.primary,
            fontWeight: "bold",
            fontSize: 18,
            "&: hover": {
                color: (theme) => theme.palette.primary.main,
                backgroundColor: "transparent"
            }
        },
        typography: {
            textAlign: "center",
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 2,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                fontSize: 45,
                textAlign: "left"
            }
        },
        footerStyle: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            textAlign: "center"
        },
        label: {
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 4,
        },
        divider: {
            marginTop: 4,
            marginBottom: 4
        },
        cardDashboard: {
            borderRadius: 0,
            boxShadow: 0,
            minHeight: 90,
            opacity: 0.9
        },
        actionButton: {
            margin: 0,
            padding: 1,
            height: 23,
            backgroundColor: "#B9E291",
            boxShadow: 0,
            borderRadius: 0,
            fontSize: 12,
        },
        scrollableDiv: {
            maxHeight: "100vh",
            '@media only screen and (min-width: 1700px)': {
                height: 700
            },
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            overflow: 'auto',
            //for other browsers 
            scrollbarWidth: "none"
        },
        sideDiv: {
            position: "sticky",
            height: 500

        },
    }


    const [visibility, setVisibility] = useState(false);
    const handleClickShowPassword = () => {
        setVisibility((prev) => !prev);
    };

    const dispatch = useDispatch()

    const signOut = (e) => {
        e.preventDefault();
        dispatch(userLogout())
    }

    const [edit, setEdit] = useState(false);


    const [payload, setPayload] = useState({})

    const [changed, setChanged] = useState({
        userID: "",
        userFirstName: "",
        userLastName: "",
        userAddress: "",
        userEmail: "",
        userContact: "",
        libraryNumber: "",
        borrowerCard: "",
        userPass: "",
    })

    useEffect(() => {
        if (Object.keys(user.currentUser).length > 0) {
            setPayload(user.currentUser)
            setChanged(user.currentUser)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const checkChanges = (propItem) => {
        return changed[propItem] !== payload[propItem]
    }
    const handleChange = (prop) => (e) => {
        setPayload({ ...payload, [prop]: e.target.value });
    };

    const saveChanges = (e) => {
        e.preventDefault();
        if (!payload.userFirstName || !payload.userLastName || !payload.userAddress || !payload.userEmail || !payload.userContact) {
            setAlert({
                message: "Please make sure to fill in the empty fields.",
                severity: "warning"
            })
            setSnack(true)
        } else {
            var added = updateProfile(payload);
            if (added) {
                setAlert({
                    message: "Profile successfuly updated.",
                    severity: "success"
                })
                setSnack(true)
                setEdit(false)
            }
        }
    }

    const [snack, setSnack] = useState(false)

    const [alert, setAlert] = useState({
        message: "This is an alert message.",
        severity: "success",
    })


    const handleSnack = () => {
        setSnack(false);
    }

    const vertical = screenSize ? "bottom" : "top";
    const horizontal = "center";
    return (
        <Box>
            <SEO title="Settings - Baliwag Municipal Library" description="RANIELLA VILLARAMA WEB DEVELOPER PORTFOLIO ... Services offered" />
            <Paper sx={style.background} elevation={0}>
                <Header />
                <Box sx={style.body}>
                    <Grid container columns={12} spacing={1}>
                        {!matches && <Grid item xs={12} md={3} sx={{ padding: 3 }}>
                            <Menu />
                        </Grid>}
                        <Grid item xs={12} md={matches ? 12 : 9}>
                            <Box sx={style.scrollableDiv}>
                                <Stack direction="column" sx={{ marginBottom: 2 }}>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: "#280707" }}>Settings</Typography>
                                    <Typography variant="subtitle2" sx={{ fontStyle: 'italic', color: "#280707" }}>Update your details here.</Typography>
                                </Stack>
                                <Stack direction="column" spacing={2} sx={{ marginTop: 3 }}>
                                    <Grid container columns={12} spacing={3} justifyContent="center">
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                fullWidth
                                                label='First Name'
                                                value={payload.userFirstName || ""}
                                                onChange={handleChange("userFirstName")}
                                                focused={edit && checkChanges("userFirstName")}
                                                inputProps={
                                                    { readOnly: !edit, }
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                fullWidth
                                                label='Last Name'
                                                value={payload.userLastName || ""}
                                                onChange={handleChange("userLastName")}
                                                inputProps={
                                                    { readOnly: !edit, }
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                fullWidth
                                                label='Address'
                                                value={payload.userAddress || ""}
                                                onChange={handleChange("userAddress")}
                                                inputProps={
                                                    { readOnly: !edit, }
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                fullWidth
                                                label='Contact Number'
                                                onChange={handleChange("userContact")}
                                                value={payload.userContact || ""}
                                                inputProps={
                                                    { readOnly: !edit, }
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                fullWidth
                                                label='Library Number'
                                                value={payload.libraryNumber || ""}
                                                onChange={handleChange("libraryNumber")}
                                                inputProps={
                                                    { readOnly: !edit, }
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                fullWidth
                                                label='Borrower Card'
                                                value={payload.borrowerCard || ""}
                                                onChange={handleChange("borrowerCard")}
                                                inputProps={
                                                    { readOnly: !edit, }
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={12} >
                                            <FormControl fullWidth variant="outlined">
                                                <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                                                <OutlinedInput
                                                    inputProps={
                                                        { readOnly: !edit, }
                                                    }
                                                    id="outlined-adornment-password"
                                                    fullWidth
                                                    value={payload.userPass || ""}
                                                    label='Password'
                                                    type={visibility ? "text" : "password"}
                                                    endAdornment={
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={handleClickShowPassword}
                                                                edge="end"
                                                            >
                                                                {visibility ? <VisibilityOff /> : <Visibility />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    }
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                    <Stack
                                        direction={fullScreen ? "row" : "column"}
                                        alignItems="center"
                                        justifyContent="center"
                                        spacing={1}
                                        sx={{
                                            paddingLeft: fullScreen ? 5 : 2,
                                            paddingRight: fullScreen ? 5 : 2,
                                        }}
                                    >
                                        {edit ?
                                            <Button
                                                variant="outlined"
                                                fullWidth
                                                onClick={saveChanges}
                                                endIcon={<SaveOutlined />}
                                                sx={{
                                                    textAlign: "center",
                                                    borderColor: (theme) => theme.palette.success.main,
                                                    color: (theme) => theme.palette.success.main,
                                                    "&:hover": {
                                                        borderColor: (theme) => theme.palette.success.main,
                                                        boxShadow: 1,

                                                    },
                                                }}>
                                                Save Changes
                                            </Button> :
                                            <Button
                                                variant="outlined"
                                                fullWidth
                                                onClick={() => setEdit(true)}
                                                endIcon={<EditOutlined />}
                                                sx={{
                                                    textAlign: "center",
                                                }}>
                                                Edit Profile
                                            </Button>

                                        }
                                        <Button
                                            variant="contained"
                                            onClick={signOut}
                                            fullWidth
                                            endIcon={<LogoutOutlined />}
                                            sx={{
                                                textAlign: "center",
                                                backgroundColor: (theme) => theme.palette.error.main,
                                                "&:hover": {
                                                    backgroundColor: (theme) => theme.palette.error.light,

                                                },
                                            }}>
                                            Log-Out
                                        </Button>
                                    </Stack>
                                </Stack>
                                <Box sx={{height: 200}} />

                            </Box>
                        </Grid>
                    </Grid>

                </Box>
            </Paper>
            <Snackbar open={snack} autoHideDuration={6000} onClose={handleSnack} anchorOrigin={{ vertical, horizontal }}>
                <Alert onClose={handleSnack} severity={alert.severity} sx={{ width: '100%' }}>
                    {alert.message}
                </Alert>
            </Snackbar>
            <Box sx={style.footerStyle}>
                {matches ?
                    <BottomMenu />
                    :
                    <Footer />}
            </Box>

        </Box>
    )
}
